import { Dimensions, StyleSheet, View, Image } from "react-native";
import React from "react";
import { Text } from "../../../components/Themed";
import Colors from "../../../constants/Colors";

const { width } = Dimensions.get("window");

interface QuestionInputProps {
  question: string;
  details: string;
}

const QuestionInput: React.FC<QuestionInputProps> = ({ question, details }) => {
  return (
    <View style={styles.page}>
      <View style={styles.container}>
        <Text size={26} lineHeight={28} style={styles.questionText}>
          {question}
        </Text>
        <Text size={20} lineHeight={28} style={styles.detailsText}>
          {details}
        </Text>
        <Image
          source={require("../../../assets/Frame.png")}
          style={{ width: 200, height: 200, alignSelf: "center" }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  page: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    padding: 40,
  },
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: 500,
    maxHeight: 500,
  },
  questionText: {
    marginBottom: 20,
    textAlign: "center",
    color: Colors.nuetral_grey_700,
  },
  detailsText: {
    textAlign: "center",
    color: Colors.nuetral_grey_700,
    marginBottom: 40,
  },
  infoText: {
    fontSize: 14,
    lineHeight: 20,
    color: Colors.nuetral_grey_600,
    marginTop: -20,
  },
});

export default QuestionInput;
